<template>
  <!-- Container principal do carrossel de avisos -->
  <div class="carousel-container-avisos" v-if="this.contemAvisos">
    <!-- Cabeçalho do Mural de Avisos com ícone e badge -->
    <div class="avisos-header-box">
      <div class="avisos-title-wrapper">
        <i class="pi pi-bell avisos-bell-icon"></i>
        <span class="avisos-header-title">Mural de Avisos da Prefeitura</span>
      </div>
      <span class="avisos-badge" v-if="items && items.length">
        <i class="pi pi-info-circle"></i>
        {{ items.length }} {{ items.length === 1 ? 'comunicado disponível' : 'comunicados disponíveis' }}
      </span>
    </div>

    <div class="carousel-avisos-wrapper">
      <button
        @click="prevSlide"
        class="carousel-control-avisos prev-avisos"
        :disabled="currentIndex === 0"
        :class="{ disabled: currentIndex === 0 }"
        aria-label="Slide anterior"
      >
        <img class="setas-navegacao" src="@/assets/icons/seta-left.svg" alt="Seta para a esquerda" />
      </button>

      <div class="carousel-avisos">
        <div class="carousel-track" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">          
          <div class="carousel-slide-avisos" v-for="(slide, slideIndex) in groupedItems" :key="slideIndex">
            <button
              class="carousel-item-avisos"
              v-for="(item, index) in slide"
              :key="index"
              @click="showAviso(item.objeto)"
            >
              <div class="card-avisos">
                <div class="card-avisos-meta">
                  <span class="card-avisos-date">
                    <i class="pi pi-calendar"></i>
                    {{ item.date }}
                  </span>
                  <span class="card-avisos-tag">Comunicado</span>
                </div>
                <h3 class="card-avisos-title">{{ item.title }}</h3>
                <p class="card-avisos-excerpt" v-html="truncateText(item.content, isSmallDevice ? 100 : 160)"></p>
                <div class="card-avisos-footer">
                  <span class="card-avisos-action">
                    Ler aviso completo
                    <i class="pi pi-arrow-right"></i>
                  </span>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>

      <button
        @click="nextSlide"
        class="carousel-control-avisos next-avisos"
        :disabled="isAtEnd"
        :class="{ disabled: isAtEnd }"
        aria-label="Próximo slide"
      >
        <img class="setas-navegacao" src="@/assets/icons/seta-right.svg" alt="Seta para a direita" />
      </button>
    </div>

    <!-- MODAL DE DETALHES DO AVISO -->
    <Dialog
      class="dialog-modern-clean dialog-avisos"
      :visible.sync="displayAviso"
      :modal="true"
      :showHeader="false"
      v-if="avisoAtual && avisoAtual.titulo"
      :style="{ width: '62vw', maxWidth: '820px' }"
      style="backdrop-filter: blur(4px);"
    >
      <div class="aviso-dialog-wrapper">
        <!-- HEADER -->
        <div class="modal-header-modern aviso-header">
          <div class="modal-header-left">
            <div class="modal-header-icon aviso-icon-badge">
              <i class="pi pi-bell"></i>
            </div>
            <div class="aviso-header-titles">
              <div class="aviso-meta-row">
                <span class="aviso-meta-tag">Comunicado Oficial</span>
                <span class="aviso-meta-date" v-if="avisoAtual.dataFormatada">
                  <i class="pi pi-calendar"></i>
                  {{ avisoAtual.dataFormatada }}
                </span>
              </div>
              <h1 class="modal-header-title aviso-titulo-modal">{{ avisoAtual.titulo }}</h1>
            </div>
          </div>
          <button @click="hideAviso()" type="button" class="btn-modal-close" title="Fechar comunicado">
            <img src="@/assets/icons/icon-close.svg" alt="Fechar" class="icon-close" />
          </button>
        </div>

        <!-- BODY -->
        <div class="aviso-body-scroll">
          <!-- TIPO T: Texto Livre / HTML -->
          <div
            v-if="avisoAtual.tipo === 'T'"
            class="aviso-conteudo-html"
            v-html="avisoAtual.mensagem"
          ></div>

          <!-- TIPO Q: Pergunta e Resposta (FAQ / Esclarecimentos) -->
          <div v-if="avisoAtual.tipo === 'Q'" class="aviso-qa-box">
            <div
              class="aviso-qa-assunto-card"
              v-if="avisoAtual.avisoAssunto && avisoAtual.avisoAssunto.assunto"
            >
              <div class="aviso-qa-badge-label">
                <i class="pi pi-tag"></i>
                <span>Assunto</span>
              </div>
              <div class="aviso-qa-assunto-text" v-html="avisoAtual.avisoAssunto.assunto"></div>
            </div>

            <div
              class="aviso-qa-item pergunta"
              v-if="avisoAtual.avisoItem && avisoAtual.avisoItem.pergunta"
            >
              <div class="aviso-qa-badge-label pergunta">
                <i class="pi pi-question-circle"></i>
                <span>Pergunta</span>
              </div>
              <div class="aviso-qa-item-content" v-html="avisoAtual.avisoItem.pergunta"></div>
            </div>

            <div
              class="aviso-qa-item resposta"
              v-if="avisoAtual.avisoItem && avisoAtual.avisoItem.resposta"
            >
              <div class="aviso-qa-badge-label resposta">
                <i class="pi pi-check-circle"></i>
                <span>Resposta</span>
              </div>
              <div class="aviso-qa-item-content" v-html="avisoAtual.avisoItem.resposta"></div>
            </div>
          </div>
        </div>

        <!-- FOOTER -->
        <div class="modal-actions-footer aviso-footer">
          <button type="button" class="btn-modal-secondary" @click="hideAviso()">
            <i class="pi pi-times"></i>
            <span>Fechar</span>
          </button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import DnsClienteService from "@/services/nfse/dns.cliente.service"; // Importa o serviço de DNS para cliente relacionado a NFSe
import LoginService from "@/services/acesso/login.service";
// Definição do componente
export default {
  // Dados do componente
  data() {
    return {
      displayAviso: false,
      avisoAtual: null,
      contemAvisos: false,
      avisos: [],
      currentIndex: 0,
      items: [],
      itemsPerSlide: 2,
      isSmallDevice: false,
    };
  },
  computed: {
    groupedItems() {
      const groups = [];
      for (let i = 0; i < this.items.length; i += this.itemsPerSlide) {
        groups.push(this.items.slice(i, i + this.itemsPerSlide));
      }
      return groups;
    },
    isAtEnd() {
      return this.currentIndex >= this.groupedItems.length - 1;
    },
  },
  methods: {
    hideAviso(){
      this.displayAviso = false;
    },
    showAviso(aviso){
      this.avisoAtual = aviso;
      this.displayAviso = true;
    },
    formatarData(data) {
      if (!data) return '';
      if (typeof data === 'string') {
        const datePart = data.split('T')[0];
        const partes = datePart.split('-');
        if (partes.length === 3) {
          return `${partes[2]}/${partes[1]}/${partes[0]}`;
        }
        if (data.includes('/')) {
          return data;
        }
      }
      const d = new Date(data);
      const dia = String(d.getUTCDate()).padStart(2, '0');
      const mes = String(d.getUTCMonth() + 1).padStart(2, '0');
      const ano = d.getUTCFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    montarAvisos() {
      let retorno = [];
      const self = this;
      if (this.avisos && this.avisos.length > 0) {
        this.avisos.forEach(function (aviso) {
          if (aviso && aviso.tipoEnvio !== 'P') {
            retorno.push(
              {
                date: aviso.dataFormatada || self.formatarData(aviso.dataVigenciaInicial),
                title: aviso.titulo,
                content: aviso.mensagem || '',
                objeto: aviso
              }
            );
          }
        });
      }
      this.contemAvisos = retorno.length > 0;
      return retorno;
    },
    nextSlide() {
      if (this.currentIndex < this.groupedItems.length - 1) {
        this.currentIndex++;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.slice(0, maxLength) + '...';
    },
    goToAviso(link) {
      window.location.href = link;
    },
    handleResize() {
      if (window.innerWidth <= 1024) {
        this.itemsPerSlide = 1;
        this.isSmallDevice = true;
      } else {
        this.itemsPerSlide = 2;
        this.isSmallDevice = false;
      }
      this.currentIndex = 0;
    },
  },
  // Hooks do ciclo de vida
  mounted() {
    this.avisos = [];
    setTimeout(async () => {
      let host = window.location.hostname;
      let dnsCliente = await DnsClienteService.get(host);                           // Busca os dados do cliente DNS usando o hostname

      // Verifica se os dados do cliente DNS estão disponíveis
      if (
        dnsCliente &&
        dnsCliente.data &&
        dnsCliente.data.idCliente
      ) {
        let idCliente = dnsCliente.data.idCliente;
        LoginService.findAllAvisos(idCliente).then((res) => {
          this.avisos = res.data;
          this.items = this.montarAvisos();
        })
      }
    }, 250);
    // Chama handleResize quando o componente é montado
    this.handleResize();
    // Adiciona um listener para o evento de redimensionamento da janela
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // Remove o listener de redimensionamento quando o componente é destruído
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<!-- Importa estilos adicionais -->
<style src="@/assets/css/avisosCarousel.css"></style>
